export const basicList = [
  {
    subTit: '企业通讯录',
    url: '/enterprise/address',
    code: '1120302',
    isInside: true,
    name: 'enterpriseAddress'
  },
  {
    subTit: '应用管理',
    url: '/enterprise/application',
    code: '112030301',
    isInside: true,
    // name: 'enterpriseApplicationConfig'
    name: 'dataPosition'
  },

  {
    subTit: '公告管理',
    url: '/enterprise/notice',
    code: '112030302',
    isInside: true,
    name: 'enterpriseNotice'
  },

  {
    subTit: '基础信息设置',
    url: '/enterprise/basic',
    code: '112030401',
    isInside: true,
    name: 'enterpriseBasic'
  },
  {
    subTit: '权限管理',
    url: '/enterprise/role',
    code: '112030402',
    isInside: true,
    name: 'enterpriseRole'
  }

]

// 数据管理
export const dataList = [
  {
    subTit: '项目管理',
    url: '/manage/mainData/project',
    code: '1120403',
    isInside: false,
    name: 'dataProject'
  },

  {
    subTit: '楼栋管理',
    url: '/manage/mainData/building',
    code: '1120404',
    isInside: false,
    name: 'dataBuilding'
  },
  // {
  //   subTit: '标段管理',
  //   url: '/mainData/tender',
  //   code: '1120405',
  //   name: 'dataTender'
  // },
  {
    subTit: '房间管理',
    url: '/manage/mainData/buildingRoom',
    code: '1120406',
    isInside: false,
    name: 'dataBuilding'
  },
  {
    subTit: '户型管理',
    url: '/manage/mainData/houseType',
    code: '1120407',
    isInside: false,
    name: 'dataDoorModel'
  },
  {
    subTit: '部位管理',
    url: '/manage/mainData/part',
    code: '1120408',
    isInside: false,
    name: 'dataPosition'
  },
  {
    subTit: '合作方管理',
    // url: '/manage/contractorManage/contractor',
    url: '/mainData/contractor',
    code: '1120409',
    isInside: true,
    name: 'dataContractor'
  },
  {
    subTit: '操作日志',
    url: '/mainData/operateLog',
    code: '1120410',
    isInside: true,
    name: 'operateLog'
  }
]

